// import { useEffect, useState, useMemo, useCallback } from "react";
// import {
//     Table,
//     Button,
//     Modal,
//     Input,
//     Select,
//     Tag,
//     Space,
//     Upload,
//     message,
//     Tooltip,
//     Badge,
//     Typography,
//     Divider,
//     Row,
//     Col,
//     Empty,
// } from "antd";
// import Notification from "../../composants/Notification";
// import {
//     PlusOutlined,
//     UploadOutlined,
//     FolderOpenOutlined,
//     FileTextOutlined,
//     ClockCircleOutlined,
//     CheckCircleOutlined,
//     SyncOutlined,
//     ExclamationCircleOutlined,
//     InboxOutlined,
//     ApartmentOutlined,
//     EditOutlined,
//     DownloadOutlined,
//     SwapOutlined,
//     CalculatorOutlined,
//     MinusCircleOutlined,
// } from "@ant-design/icons";
// import { get_ListeClients } from "../../api/clients";
// import {
//     attachTransitDocument,
//     createDevisTransit,
//     createDossier,
//     downloadTransitDocument,
//     getAllCategoriesTransit,
//     getAllDossier,
//     getAllTransitDocument,
//     getDevisTransit,
//     getMMarchandises,
//     updateDevisTransit,
//     updateDossier,
//     updateDossierStatus,
// } from "../../api/provision";
// import { get_ListeRegion } from "../../api/region";
// import formatDateFr from "../../utils/utils";

// const { Title, Text } = Typography;
// const { Option } = Select;
// const { Dragger } = Upload;

// const STATUS_STYLES = {
//     processing: { color: "processing", icon: <SyncOutlined spin />, hex: "#1677ff" },
//     warning: { color: "warning", icon: <ClockCircleOutlined />, hex: "#faad14" },
//     success: { color: "success", icon: <CheckCircleOutlined />, hex: "#52c41a" },
//     error: { color: "error", icon: <ExclamationCircleOutlined />, hex: "#ff4d4f" },
// };

// const statusConfig = {
//     attente_masoandro: { ...STATUS_STYLES.processing, label: "En attente devis" },
//     devis_envoyes: { ...STATUS_STYLES.success, label: "Devis envoyé" },
// };

// const SECTION_KEYS = ["PRESTATION MASOANDRO", "A L'IDENTIQUE"];


// export default function Dossier() {
//     const initialFormData = {
//         id: null,
//         typeMarchandise: "",
//         marchandises: "",
//         typeConteneur: "",
//         nbConteneur: "",
//         numeroConteneur: "",
//         nbColis: 0,
//         poids: "",
//         volume: "",
//         origine: "",
//         destination: "",
//         client: "",
//         referenceBL: "",
//         paiement: "Espece",
//     };

//     const inputStyle = { borderRadius: 8, height: 36 };
//     const sectionStyle = {
//         background: "#fafbff",
//         border: "1px solid #eef0ff",
//         borderRadius: 12,
//         padding: "14px 16px",
//         marginBottom: 12,
//     };
//     const sectionLabelStyle = {
//         display: "block",
//         fontWeight: 700,
//         fontSize: 12,
//         color: "#6366f1",
//         textTransform: "uppercase",
//         letterSpacing: "0.6px",
//         marginBottom: 10,
//     };

//     const FieldLabel = ({ children }) => (
//         <Text style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 4 }}>
//             {children}
//         </Text>
//     );

//     // ─── State ─────────────────────────────────────────────────────────────────
//     const [allDocuments, setallDocuments] = useState([]);
//     const [dossiers, setDossiers] = useState([]);
//     const [isUpdate, setIsUpdate] = useState(false);
//     const [createModalOpen, setCreateModalOpen] = useState(false);
//     const [uploadModalOpen, setUploadModalOpen] = useState(false);
//     const [devisModalOpen, setDevisModalOpen] = useState(false);
//     const [selectedDossier, setSelectedDossier] = useState(null);
//     const [uploadedFile, setUploadedFile] = useState(null);
//     const [denomination, setDenomination] = useState("");
//     const [formData, setFormData] = useState(initialFormData);
//     const [listeClient, setListeClients] = useState([]);
//     const [allMarchandises, setAllMarchandises] = useState([]);
//     const [listeRegion, setlisteRegion] = useState([]);
//     const [showToast, setshowToast] = useState(false);
//     const [notif, setnotif] = useState({ message: null, info: null });
//     const [loading, setLoading] = useState(false);
//     const [listeCategories, setlisteCategories] = useState({});
//     const [statusModalOpen, setStatusModalOpen] = useState(false);
//     const [newStatus, setNewStatus] = useState(null);
//     const [devisInfo, setdevisInfo] = useState(null);

//     // ─── Helpers partagés mémorisés ─────────────────────────────────────────────────────
//     const buildEmptyLine = useCallback((section) => {
//         const firstItem = listeCategories[section]?.[0];
//         return {
//             key: Date.now() + Math.random(),
//             categorie_id: firstItem?.categorie_id ?? null,
//             nom: firstItem?.nom ?? "",
//             prix: 0,
//         };
//     }, [listeCategories]);

//     const computeTotal = useCallback((lines) => {
//         return Object.values(lines)
//             .flat()
//             .reduce((sum, l) => sum + (Number(l.prix) || 0), 0);
//     }, []);

//     const mapDevisToLines = useCallback((devisInfos, prestationsData, sectionKeys) => {
//         const result = sectionKeys.reduce((acc, key) => {
//             acc[key] = [];
//             return acc;
//         }, {});

//         devisInfos.forEach((item) => {
//             for (const section of sectionKeys) {
//                 const found = prestationsData[section]?.find(
//                     (p) => p.categorie_id === item.categorie_id
//                 );
//                 if (found) {
//                     result[section].push({
//                         key: Date.now() + Math.random(),
//                         categorie_id: item.categorie_id,
//                         nom: found.nom,
//                         prix: item.montant,
//                     });
//                     break;
//                 }
//             }
//         });

//         return result;
//     }, []);

//     // ─── PrestationModal ───────────────────────────────────────────────────────
//     const PrestationModal = useCallback(({ open, onClose }) => {
//         const [prestationLines, setPrestationLines] = useState(
//             SECTION_KEYS.reduce((acc, k) => ({ ...acc, [k]: [] }), {})
//         );

//         const hasDevis = !!selectedDossier?.devis_id;
//         const canEdit = !hasDevis || devisInfo?.devis_statut !== "validaté";

//         // Initialisation des lignes à l'ouverture du modal
//         useEffect(() => {
//             if (!open) return;

//             if (hasDevis && devisInfo?.devis_infos?.length) {
//                 const mapped = mapDevisToLines(devisInfo.devis_infos, listeCategories, SECTION_KEYS);
//                 setPrestationLines(mapped);
//             } else {
//                 setPrestationLines(SECTION_KEYS.reduce((acc, k) => ({ ...acc, [k]: [] }), {}));
//             }
//         }, [open, hasDevis]);

//         // Helpers locaux mémorisés
//         const handleAddLine = useCallback((section) => {
//             setPrestationLines((prev) => ({
//                 ...prev,
//                 [section]: [...prev[section], buildEmptyLine(section)],
//             }));
//         }, [buildEmptyLine]);

//         const handleRemoveLine = useCallback((section, key) => {
//             setPrestationLines((prev) => ({
//                 ...prev,
//                 [section]: prev[section].filter((l) => l.key !== key),
//             }));
//         }, []);

//         const handleChangeLine = useCallback((section, key, field, value) => {
//             setPrestationLines((prev) => {
//                 const newLines = { ...prev };
//                 newLines[section] = prev[section].map((l) => {
//                     if (l.key !== key) return l;
//                     if (field === "nom") {
//                         const found = listeCategories[section]?.find((p) => p.nom === value);
//                         return {
//                             ...l,
//                             nom: value,
//                             categorie_id: found?.categorie_id ?? l.categorie_id
//                         };
//                     }
//                     return { ...l, [field]: value };
//                 });
//                 return newLines;
//             });
//         }, [listeCategories]);

//         // SectionBlock LOCAL mémorisé
//         const SectionBlock = useCallback(({ sectionKey, lines, accentColor }) => (
//             <div style={{ marginBottom: 24 }}>
//                 <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
//                     <Space size={8}>
//                         <span style={{ width: 8, height: 8, borderRadius: "50%", background: accentColor, display: "inline-block" }} />
//                         <Text strong style={{ fontSize: 13, letterSpacing: "0.02em" }}>{sectionKey}</Text>
//                         <Tag color={accentColor} style={{ borderRadius: 10, fontSize: 11 }}>
//                             {lines.length} ligne{lines.length > 1 ? "s" : ""}
//                         </Tag>
//                     </Space>
//                     {canEdit && (
//                         <Button
//                             size="small"
//                             icon={<PlusOutlined />}
//                             onClick={() => handleAddLine(sectionKey)}
//                             style={{ borderRadius: 6, fontSize: 12 }}
//                         >
//                             Ajouter
//                         </Button>
//                     )}
//                 </div>

//                 {lines.length > 0 && (
//                     <Row gutter={8} style={{ padding: "0 4px", marginBottom: 4 }}>
//                         <Col flex="auto"><Text type="secondary" style={{ fontSize: 11 }}>Prestation</Text></Col>
//                         <Col style={{ width: 150 }}><Text type="secondary" style={{ fontSize: 11 }}>Prix (Ar)</Text></Col>
//                         {canEdit && <Col style={{ width: 32 }} />}
//                     </Row>
//                 )}

//                 {lines.length === 0 ? (
//                     <Empty description="Aucune ligne" image={Empty.PRESENTED_IMAGE_SIMPLE} style={{ margin: "12px 0" }} />
//                 ) : (
//                     <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
//                         {lines.map((line) => (
//                             <Row
//                                 key={line.key}
//                                 gutter={8}
//                                 align="middle"
//                                 style={{ background: "#f5f5f5", borderRadius: 8, padding: "6px 10px" }}
//                             >
//                                 <Col flex="auto">
//                                     <Select
//                                         size="small"
//                                         value={line.nom}
//                                         style={{ width: "100%" }}
//                                         disabled={!canEdit}
//                                         onChange={(val) => handleChangeLine(sectionKey, line.key, "nom", val)}
//                                         options={(listeCategories[sectionKey] || []).map((p) => ({ label: p.nom, value: p.nom }))}
//                                     />
//                                 </Col>
//                                 <Col style={{ width: 150 }}>
//                                     <Input
//                                         size="small"
//                                         style={{ width: "100%" }}
//                                         value={line.prix}
//                                         disabled={!canEdit}
//                                         onChange={(e) => handleChangeLine(sectionKey, line.key, "prix", e.target.value)}
//                                     />
//                                 </Col>
//                                 {canEdit && (
//                                     <Col style={{ width: 32 }}>
//                                         <Button
//                                             danger
//                                             size="small"
//                                             icon={<MinusCircleOutlined />}
//                                             shape="default"
//                                             style={{ borderRadius: 6, width: 28, padding: 0 }}
//                                             onClick={() => handleRemoveLine(sectionKey, line.key)}
//                                         />
//                                     </Col>
//                                 )}
//                             </Row>
//                         ))}
//                     </div>
//                 )}
//             </div>
//         ), [canEdit, handleAddLine, handleChangeLine, handleRemoveLine, listeCategories]);

//         const total = computeTotal(prestationLines);

//         const handleClose = useCallback(() => {
//             setPrestationLines(SECTION_KEYS.reduce((acc, k) => ({ ...acc, [k]: [] }), {}));
//             onClose();
//         }, [onClose]);

//         const handleSubmitPrestation = async () => {
//             const isUpdating = hasDevis && devisInfo?.devis_statut !== "validate";
//             const payload = Object.entries(prestationLines).flatMap(([section, lines]) =>
//                 lines.map(({ categorie_id, nom, prix }) => ({
//                     section,
//                     categorie_id,
//                     nom,
//                     prix: Number(prix),
//                     dossier_id: selectedDossier?.id,
//                     ...(isUpdating && { devis_id: selectedDossier?.devis_id }),
//                 }))
//             );

//             const res = isUpdating
//                 ? await updateDevisTransit(payload)
//                 : await createDevisTransit(payload);

//             const mess = isUpdating ? "Devis mis à jour avec succès !!!" : "Devis généré avec succès !!!";
//             const mess_error = isUpdating ? "Erreur mise à jour devis !!!" : "Erreur génération !!!";

//             if (res.status === "success") {
//                 setnotif({ message: mess, info: "success" });
//                 setshowToast(true);
//                 setTimeout(() => { window.location.reload(); }, 1500);
//             } else {
//                 message.warning(mess_error);
//                 setnotif({ message: mess_error, info: "error" });
//                 setshowToast(true);
//                 setTimeout(() => { setshowToast(false); }, 1500);
//             }
//             handleClose();
//         };

//         return (
//             <Modal
//                 open={open}
//                 onCancel={handleClose}
//                 title={
//                     <div>
//                         <div style={{ fontWeight: 500, fontSize: 16 }}>
//                             {hasDevis ? "Devis existant" : "Générer un devis"}
//                             {selectedDossier && (
//                                 <span style={{ marginLeft: 8, fontSize: 13, color: "#6366f1", fontFamily: "'DM Mono', monospace" }}>
//                                     — {selectedDossier.ref}
//                                 </span>
//                             )}
//                         </div>
//                         <div style={{ fontWeight: 400, fontSize: 13, color: "#8c8c8c" }}>
//                             {hasDevis
//                                 ? canEdit
//                                     ? "Vous pouvez modifier ce devis (dossier validé)"
//                                     : "Consultation uniquement — le dossier doit être validé pour modifier"
//                                 : "Ajoutez les lignes de prestation selon vos besoins"}
//                         </div>
//                     </div>
//                 }
//                 footer={
//                     <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                         <Text type="secondary" style={{ fontSize: 13 }}>
//                             Total :{" "}
//                             <Text strong style={{ fontSize: 15 }}>
//                                 {total.toLocaleString("fr-MG")} Ar
//                             </Text>
//                         </Text>
//                         <Space>
//                             <Button onClick={handleClose}>
//                                 {canEdit ? "Annuler" : "Fermer"}
//                             </Button>
//                             {canEdit && (
//                                 <Button
//                                     type="primary"
//                                     onClick={handleSubmitPrestation}
//                                     style={{
//                                         background: "linear-gradient(135deg, #6366f1, #4f46e5)",
//                                         border: "none",
//                                         borderRadius: 8,
//                                         fontWeight: 600,
//                                     }}
//                                 >
//                                     {hasDevis ? "Modifier le devis" : "Enregistrer le devis"}
//                                 </Button>
//                             )}
//                         </Space>
//                     </div>
//                 }
//                 width={600}
//                 styles={{ body: { maxHeight: "60vh", overflowY: "auto", padding: "20px 24px" } }}
//             >
//                 {hasDevis && !canEdit && (
//                     <div style={{
//                         background: "#fff7e6",
//                         border: "1px solid #ffd591",
//                         borderRadius: 8,
//                         padding: "8px 14px",
//                         marginBottom: 16,
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 8,
//                         fontSize: 13,
//                         color: "#d46b08",
//                     }}>
//                         <ExclamationCircleOutlined />
//                         <span>La modification du devis est réservée aux dossiers avec le statut <strong>validé</strong>.</span>
//                     </div>
//                 )}

//                 <SectionBlock
//                     sectionKey="PRESTATION MASOANDRO"
//                     lines={prestationLines["PRESTATION MASOANDRO"]}
//                     accentColor="#185FA5"
//                 />

//                 <Divider style={{ margin: "4px 0 20px" }} />

//                 <SectionBlock
//                     sectionKey="A L'IDENTIQUE"
//                     lines={prestationLines["A L'IDENTIQUE"]}
//                     accentColor="#3B6D11"
//                 />
//             </Modal>
//         );
//     }, [selectedDossier, devisInfo, listeCategories, buildEmptyLine, computeTotal, mapDevisToLines]);

//     // ─── Data fetching ─────────────────────────────────────────────────────────
//     useEffect(() => {
//         fetchAllCategorie();
//         fetchAllTypeDocument();
//         fetchListeClients();
//         fetchMarchandise();
//         fetchListeRegion();
//         fetchAllDossier();
//     }, []);

//     const fetchAllDossier = async () => {
//         setLoading(true);
//         const res = await getAllDossier();
//         setDossiers(res.data);
//         setLoading(false);
//     };

//     const fetchAllCategorie = async () => {
//         setLoading(true);
//         const res = await getAllCategoriesTransit();
//         const categories = res.data;
//         const grouped = categories.reduce((acc, item) => {
//             if (!acc[item.type]) acc[item.type] = [];
//             acc[item.type].push({ categorie_id: item.id, nom: item.nom, prix: 0 });
//             return acc;
//         }, {});
//         setlisteCategories(grouped);
//         setLoading(false);
//     };

//     const fetchListeClients = async () => {
//         const res = await get_ListeClients();
//         setListeClients(res.data);
//     };

//     const fetchAllTypeDocument = async () => {
//         const res = await getAllTransitDocument();
//         setallDocuments(res.data);
//     };

//     const fetchListeRegion = async () => {
//         const res = await get_ListeRegion();
//         setlisteRegion(res.data);
//     };

//     const fetchMarchandise = async () => {
//         try {
//             const res = await getMMarchandises();
//             setAllMarchandises(res.data || []);
//         } catch (error) {
//             message.error("Erreur lors de la récupération des marchandises");
//         }
//     };

//     const fetchDevisInfo = async (dossier) => {
//         try {
//             const res = await getDevisTransit({
//                 devis_id: dossier?.devis_id,
//                 dossier_id: dossier?.id,
//             });

//             const data = res?.data || [];
//             if (!data.length) {
//                 setdevisInfo(null);
//                 return;
//             }

//             const devis = data[0];
//             let devisInfosParsed = [];
//             try {
//                 devisInfosParsed = devis.devis_infos ? JSON.parse(devis.devis_infos) : [];
//             } catch (e) {
//                 console.warn("Erreur parsing devis_infos", e);
//             }

//             setdevisInfo({ ...devis, devis_infos: devisInfosParsed });
//         } catch (error) {
//             console.error(error);
//             message.error("Erreur lors de la récupération du devis");
//         }
//     };

//     // ─── Handlers ──────────────────────────────────────────────────────────────
//     const handleCreateDossier = async () => {
//         if (!formData.marchandises || !formData.typeMarchandise || !formData.origine || !formData.destination || !formData.client) {
//             message.warning("Veuillez remplir les champs obligatoires : marchandises, origine, destination, client.");
//             return;
//         }

//         const newDossier = {
//             id: formData.id,
//             marchandise_id: formData.typeMarchandise,
//             marchandise: formData.marchandises,
//             region_depart_id: formData.origine,
//             region_destination_id: formData.destination,
//             client_id: formData.client,
//             ref_bl: formData.referenceBL,
//             type_conteneur: formData.typeConteneur,
//             nb_conteneur: formData.nbConteneur,
//             numero_conteneur: formData.numeroConteneur,
//             nb_colis: formData.nbColis,
//             poids: formData.poids,
//             volume: formData.volume,
//             paiement: formData.paiement,
//         };

//         let res = null;
//         if (isUpdate) {
//             res = await updateDossier(newDossier);
//         } else {
//             res = await createDossier(newDossier);
//         }

//         const mess = isUpdate ? "Dossier mis à jour avec succés" : "Dossier generé avec succés";
//         const mess_error = isUpdate ? "Erreur mise à jour Dossier !!!" : "Erreur creation Dossier !!!";

//         if (res.status === "success") {
//             setnotif({ message: mess, info: "success" });
//             setshowToast(true);
//             setTimeout(() => { window.location.reload(); }, 1500);
//         } else {
//             message.warning(mess_error);
//             setnotif({ message: mess_error, info: "error" });
//             setshowToast(true);
//             setTimeout(() => { setshowToast(false); }, 1500);
//         }
//     };

//     const handleUpload = async () => {
//         if (!uploadedFile || !denomination) {
//             message.warning("Veuillez sélectionner un fichier et renseigner sa dénomination.");
//             return;
//         }

//         const fd = new FormData();
//         fd.append("file", uploadedFile);
//         fd.append("tr_dossier_id", selectedDossier.id);
//         fd.append("tr_document_id", denomination);

//         try {
//             const res = await attachTransitDocument(fd);
//             const mess = "File uploadé avec succès !!!";
//             const mess_error = "Erreur upload !!!";
//             if (res.status === "success") {
//                 setnotif({ message: mess, info: "success" });
//                 setshowToast(true);
//                 setTimeout(() => { window.location.reload(); }, 1500);
//             } else {
//                 message.warning(mess_error);
//                 setnotif({ message: mess_error, info: "error" });
//                 setshowToast(true);
//                 setTimeout(() => { setshowToast(false); }, 1500);
//             }
//         } catch (err) {
//             console.error(err);
//             message.error("Erreur upload");
//         }

//         setUploadModalOpen(false);
//         setUploadedFile(null);
//         setDenomination("");
//     };

//     const handleDownload = async (id) => {
//         try {
//             const res = await downloadTransitDocument(id);
//             const blob = new Blob([res.data], { type: "application/zip" });
//             const url = window.URL.createObjectURL(blob);
//             const link = document.createElement("a");
//             link.href = url;
//             link.download = `dossier_${id}.zip`;
//             document.body.appendChild(link);
//             link.click();
//             link.remove();
//             window.URL.revokeObjectURL(url);
//             setnotif({ message: "Téléchargement réussi ✅", info: "success" });
//             setshowToast(true);
//             setTimeout(() => { setshowToast(false); }, 1500);
//         } catch (error) {
//             console.error(error);
//             setnotif({ message: "Erreur lors du téléchargement ❌", info: "error" });
//             setshowToast(true);
//             setTimeout(() => { setshowToast(false); }, 1500);
//         }
//     };

//     const onClickEditDossier = (record) => {
//         setIsUpdate(true);
//         setFormData({
//             id: record.id,
//             typeMarchandise: record.marchandise_id,
//             marchandises: record.marchandise,
//             typeConteneur: record.type_conteneur,
//             nbConteneur: record.nb_conteneur,
//             numeroConteneur: record.numero_conteneur,
//             nbColis: record.nbColis,
//             poids: record.poids,
//             volume: record.volume,
//             origine: record.region_depart_id,
//             destination: record.region_destination_id,
//             client: record.client_id,
//             referenceBL: record.ref_bl,
//             paiement: record.paiement,
//         });
//         setCreateModalOpen(true);
//     };

//     const onGenerateDevis = async (record) => {
//         setdevisInfo(null);
//         setSelectedDossier(record);
//         if (record.devis_id) {
//             await fetchDevisInfo(record);
//         }
//         setDevisModalOpen(true);
//     };

//     const handleChangeStatus = async () => {
//         if (!newStatus || !selectedDossier) return;
//         const res = await updateDossierStatus(selectedDossier.id, newStatus);
//         const mess = res.description;
//         const mess_error = "Erreur lors du changement de statut";
        
//         if (res.status === "success") {
//             setnotif({ message: mess, info: "success" });
//             setshowToast(true);
//             setTimeout(() => { window.location.reload(); }, 1500);
//         } else {
//             message.warning(mess_error);
//             setnotif({ message: mess_error, info: "error" });
//             setshowToast(true);
//             setTimeout(() => { setshowToast(false); }, 1500);
//         }
//     };

//     // ─── Columns ───────────────────────────────────────────────────────────────
//     const columns = useMemo(() => {
//         if (!listeClient.length || !listeRegion.length || !allMarchandises.length) {
//             return [];
//         }

//         return [
//             {
//                 title: "ID",
//                 dataIndex: "id",
//                 key: "id",
//                 width: 50,
//                 align: "center",
//                 render: (text) => (
//                     <Text strong style={{ color: "#1a1a2e", fontFamily: "'DM Mono', monospace", fontSize: 13 }}>
//                         {text}
//                     </Text>
//                 ),
//             },
//             {
//                 title: "Date creation",
//                 dataIndex: "create_at",
//                 key: "create_at",
//                 width: 150,
//                 align: "center",
//                 render: (text) => (
//                     <Text strong style={{ color: "#1a1a2e", fontFamily: "'DM Mono', monospace", fontSize: 13 }}>
//                         {formatDateFr(text)}
//                     </Text>
//                 ),
//             },
//             {
//                 title: "Réference",
//                 dataIndex: "ref",
//                 key: "ref",
//                 width: 200,
//                 align: "center",
//                 ellipsis: true,
//                 render: (text) => (
//                     <Space>
//                         <FolderOpenOutlined style={{ color: "#6366f1" }} />
//                         <Text style={{ fontSize: 13 }}>{text}</Text>
//                     </Space>
//                 ),
//             },
//             {
//                 title: "Client",
//                 key: "client_id",
//                 align: "center",
//                 width: 160,
//                 render: (_, r) => {
//                     const client = listeClient.find(c => c.id === r.client_id);
//                     return <strong style={{ fontSize: 13 }}>{client?.nom ?? "—"}</strong>;
//                 },
//                 filters: listeClient.map(c => ({ text: c.nom, value: c.id })),
//                 onFilter: (value, record) => record.client_id === value,
//             },
//             {
//                 title: "Trajet",
//                 key: "trajet",
//                 width: 160,
//                 align: "center",
//                 render: (_, r) => {
//                     const regionDepart = listeRegion.find(reg => reg.id === r.region_depart_id);
//                     const regionArrive = listeRegion.find(reg => reg.id === r.region_destination_id);
//                     return <span style={{ fontSize: 13 }}>{regionDepart?.nom ?? "?"} ➜ {regionArrive?.nom ?? "?"}</span>;
//                 },
//                 filters: listeRegion.map(r => ({ text: r.nom, value: r.id })),
//                 onFilter: (value, record) =>
//                     record.region_depart_id === value || record.region_destination_id === value,
//             },
//             {
//                 title: "Marchandises",
//                 key: "marchandise",
//                 width: 150,
//                 align: "center",
//                 render: (_, r) => {
//                     const marchandise = allMarchandises.find(m => m.id === r.marchandise_id);
//                     return (
//                         <>
//                             <span style={{ fontSize: 13 }}>{r.marchandise}</span>
//                             <br />
//                             <span style={{ fontSize: 11 }}>({marchandise?.nom ?? "N/A"})</span>
//                         </>
//                     );
//                 },
//                 filters: allMarchandises.map(m => ({ text: m.nom, value: m.id })),
//                 onFilter: (value, record) => record.marchandise_id === value,
//             },
//             {
//                 title: "Statut",
//                 dataIndex: "statut",
//                 key: "statut",
//                 align: "center",
//                 width: 140,
//                 render: (statut) => {
//                     const cfg = statusConfig?.[statut];
//                     if (!cfg) {
//                         return <Badge status="default" text={<Text style={{ fontSize: 13 }}>{statut || "Inconnu"}</Text>} />;
//                     }
//                     return (
//                         <Badge
//                             status={cfg.color}
//                             text={
//                                 <Text style={{ fontSize: 13, color: cfg.hex, fontWeight: 500 }}>
//                                     {cfg.icon} {statut}
//                                 </Text>
//                             }
//                         />
//                     );
//                 },
//                 filters: Object.keys(statusConfig).map((s) => ({ text: s, value: s })),
//                 onFilter: (value, record) => record.statut === value,
//             },
//             {
//                 title: "Action",
//                 key: "action",
//                 width: 220,
//                 fixed: 'right',
//                 align: "center",
//                 render: (_, record) => (
//                     <Space size="middle">
//                         <Tooltip title="Changer le statut">
//                             <Button
//                                 shape="circle"
//                                 icon={<SwapOutlined />}
//                                 style={{ background: "#f59e0b", border: "none", color: "#fff", boxShadow: "0 2px 6px rgba(245,158,11,0.3)" }}
//                                 onClick={() => { setSelectedDossier(record); setStatusModalOpen(true); }}
//                             />
//                         </Tooltip>

//                         <Tooltip title="Modifier le dossier">
//                             <Button
//                                 shape="circle"
//                                 icon={<EditOutlined />}
//                                 style={{ background: "#3b82f6", border: "none", color: "#fff", boxShadow: "0 2px 6px rgba(59,130,246,0.3)" }}
//                                 onMouseEnter={(e) => { e.currentTarget.style.background = "#2563eb"; }}
//                                 onMouseLeave={(e) => { e.currentTarget.style.background = "#3b82f6"; }}
//                                 onClick={() => onClickEditDossier(record)}
//                             />
//                         </Tooltip>

//                         <Tooltip title={record.devis_id ? "Voir / Modifier le devis" : "Générer devis"}>
//                             <Button
//                                 shape="circle"
//                                 icon={<CalculatorOutlined />}
//                                 style={{ background: "#8b5cf6", border: "none", color: "#fff", boxShadow: "0 2px 6px rgba(139,92,246,0.3)" }}
//                                 onMouseEnter={(e) => { e.currentTarget.style.background = "#7c3aed"; }}
//                                 onMouseLeave={(e) => { e.currentTarget.style.background = "#8b5cf6"; }}
//                                 onClick={() => onGenerateDevis(record)}
//                             />
//                         </Tooltip>

//                         <Tooltip title="Ajouter un document">
//                             <Button
//                                 type="primary"
//                                 shape="circle"
//                                 icon={<UploadOutlined />}
//                                 style={{ background: "#6366f1", border: "none", boxShadow: "0 2px 6px rgba(99,102,241,0.3)" }}
//                                 onClick={() => { setSelectedDossier(record); setUploadModalOpen(true); }}
//                             />
//                         </Tooltip>

//                         <Tooltip title="Télécharger les documents">
//                             <Button
//                                 type="primary"
//                                 shape="circle"
//                                 icon={<DownloadOutlined />}
//                                 style={{ background: "#10b981", border: "none", boxShadow: "0 2px 6px rgba(16,185,129,0.3)" }}
//                                 onMouseEnter={(e) => { e.currentTarget.style.background = "#059669"; }}
//                                 onMouseLeave={(e) => { e.currentTarget.style.background = "#10b981"; }}
//                                 onClick={() => handleDownload(record.id)}
//                             />
//                         </Tooltip>
//                     </Space>
//                 ),
//             },
//         ];
//     }, [listeClient, listeRegion, allMarchandises]);

//     // ─── Render ────────────────────────────────────────────────────────────────
//     return (
//         <div style={{ minHeight: "100vh", background: "#f8f9fe", padding: "32px 28px", fontFamily: "'DM Sans', sans-serif", width: "100%" }}>
//             <style>{`
//                 @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=DM+Mono:wght@400;500&display=swap');
//                 .dossier-table {
//                     height: 100%;
//                     overflow: auto;
//                 }
//                 .dossier-table .ant-table-thead > tr > th {
//                     background: #f1f3ff !important; color: #4338ca !important; font-weight: 600 !important;
//                     font-size: 12px !important; text-transform: uppercase; letter-spacing: 0.5px;
//                     border-bottom: 2px solid #e0e3ff !important;
//                 }
//                 .dossier-table .ant-table-row:hover > td { background: #fafaff !important; }
//                 .dossier-table .ant-table-row > td { border-bottom: 1px solid #f0f0f8 !important; transition: background 0.2s; }
//                 .stat-card { border-radius: 16px !important; border: 1.5px solid #ece9ff !important; transition: box-shadow 0.2s, transform 0.2s; }
//                 .stat-card:hover { box-shadow: 0 8px 24px rgba(99,102,241,0.10) !important; transform: translateY(-2px); }
//                 .create-btn {
//                     background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%) !important; border: none !important;
//                     border-radius: 10px !important; height: 40px !important; font-weight: 600 !important;
//                     box-shadow: 0 4px 14px rgba(99,102,241,0.35) !important; transition: box-shadow 0.2s, transform 0.2s !important;
//                 }
//                 .create-btn:hover { box-shadow: 0 6px 20px rgba(99,102,241,0.45) !important; transform: translateY(-1px); }
//                 .ant-modal-content { border-radius: 18px !important; }
//                 .ant-upload-drag { border-radius: 12px !important; border-color: #c7d2fe !important; }
//                 .ant-upload-drag:hover { border-color: #6366f1 !important; }
//             `}</style>

//             {/* Header */}
//             <div style={{ marginBottom: 28 }}>
//                 <Row justify="space-between" align="middle">
//                     <Col>
//                         <Space align="center">
//                             <div style={{
//                                 width: 44, height: 44, borderRadius: 12,
//                                 background: "linear-gradient(135deg, #6366f1, #4f46e5)",
//                                 display: "flex", alignItems: "center", justifyContent: "center",
//                                 boxShadow: "0 4px 12px rgba(99,102,241,0.3)"
//                             }}>
//                                 <ApartmentOutlined style={{ fontSize: 22, color: "#fff" }} />
//                             </div>
//                             <div>
//                                 <Title level={3} style={{ margin: 0, color: "#1a1a2e", fontFamily: "'DM Sans', sans-serif", fontWeight: 700 }}>
//                                     Gestion des Dossiers Transit
//                                 </Title>
//                                 <Text type="secondary" style={{ fontSize: 13 }}>
//                                     Suivi et gestion des opérations de transit international
//                                 </Text>
//                             </div>
//                         </Space>
//                     </Col>
//                     <Col>
//                         <Button
//                             className="create-btn"
//                             type="primary"
//                             icon={<PlusOutlined />}
//                             onClick={() => { setIsUpdate(false); setFormData(initialFormData); setCreateModalOpen(true); }}
//                         >
//                             Nouveau Dossier Transit
//                         </Button>
//                     </Col>
//                 </Row>
//             </div>

//             {/* Table */}
//             <Table
//                 className="dossier-table"
//                 dataSource={dossiers}
//                 columns={columns}
//                 rowKey="id"
//                 loading={{ spinning: loading, tip: "Chargement des dossiers..." }}
//                 pagination={{ pageSize: 4, showSizeChanger: false, style: { padding: "12px 20px" } }}
//                 size="middle"
//                 style={{ borderRadius: 18 }}
//                 scroll={{ x: "max-content" }}
//                 locale={{ emptyText: "Aucun dossier trouvé" }}
//             />

//             {/* ═══ Modal Création / Modification ═══ */}
//             <Modal
//                 title={
//                     <Space>
//                         <div style={{
//                             width: 32, height: 32, borderRadius: 8,
//                             background: "linear-gradient(135deg, #6366f1, #4f46e5)",
//                             display: "flex", alignItems: "center", justifyContent: "center"
//                         }}>
//                             <PlusOutlined style={{ color: "#fff", fontSize: 14 }} />
//                         </div>
//                         <span style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 700, color: "#1a1a2e" }}>
//                             {isUpdate ? "Mise à jour Dossier Transit" : "Nouveau Dossier Transit"}
//                         </span>
//                     </Space>
//                 }
//                 open={createModalOpen}
//                 onCancel={() => { setCreateModalOpen(false); setFormData(initialFormData); }}
//                 footer={null}
//                 width={680}
//                 centered
//             >
//                 <div style={{ marginTop: 8 }}>
//                     {/* Marchandises */}
//                     <div style={sectionStyle}>
//                         <Text style={sectionLabelStyle}>📦 Marchandises</Text>
//                         <Row gutter={12}>
//                             <Col span={12}>
//                                 <FieldLabel>Type de marchandises</FieldLabel>
//                                 <Select
//                                     style={{ width: "100%" }}
//                                     placeholder="Sélectionner..."
//                                     value={formData.typeMarchandise || undefined}
//                                     onChange={(v) => setFormData({ ...formData, typeMarchandise: v })}
//                                     showSearch
//                                 >
//                                     {allMarchandises.map((item) => (
//                                         <Option key={item.id} value={item.id}>{item.nom}</Option>
//                                     ))}
//                                 </Select>
//                             </Col>
//                             <Col span={12}>
//                                 <FieldLabel>Marchandises</FieldLabel>
//                                 <Input
//                                     placeholder="Description des marchandises"
//                                     value={formData.marchandises}
//                                     onChange={(e) => setFormData({ ...formData, marchandises: e.target.value })}
//                                     style={inputStyle}
//                                 />
//                             </Col>
//                         </Row>
//                     </div>

//                     {/* Conteneurisation */}
//                     <div style={sectionStyle}>
//                         <Text style={sectionLabelStyle}>🚢 Conteneurisation</Text>
//                         <Row gutter={12}>
//                             <Col span={8}>
//                                 <FieldLabel>Type de conteneur</FieldLabel>
//                                 <Select
//                                     style={{ width: "100%" }}
//                                     placeholder="Sélectionner..."
//                                     value={formData.typeConteneur || undefined}
//                                     onChange={(v) => setFormData({ ...formData, typeConteneur: v })}
//                                 >
//                                     <Option value="20 pieds">20 pieds</Option>
//                                     <Option value="40 pieds">40 pieds</Option>
//                                 </Select>
//                             </Col>
//                             <Col span={8}>
//                                 <FieldLabel>Nombre de conteneurs</FieldLabel>
//                                 <Input
//                                     type="number" min={1} placeholder="Ex: 2"
//                                     value={formData.nbConteneur}
//                                     onChange={(e) => setFormData({ ...formData, nbConteneur: e.target.value })}
//                                     style={inputStyle}
//                                 />
//                             </Col>
//                             <Col span={8}>
//                                 <FieldLabel>Nombre de colis</FieldLabel>
//                                 <Input
//                                     type="number" min={1} placeholder="Ex: 2"
//                                     value={formData.nbColis}
//                                     onChange={(e) => setFormData({ ...formData, nbColis: e.target.value })}
//                                     style={inputStyle}
//                                 />
//                             </Col>
//                             <Col span={8} style={{ marginTop: 12 }}>
//                                 <FieldLabel>Référence BL</FieldLabel>
//                                 <Input
//                                     placeholder="Ex: MSKU123456789"
//                                     value={formData.referenceBL}
//                                     onChange={(e) => setFormData({ ...formData, referenceBL: e.target.value })}
//                                     style={{ ...inputStyle, fontFamily: "'DM Mono', monospace", letterSpacing: "0.5px" }}
//                                 />
//                             </Col>
//                             <Col span={8} style={{ marginTop: 12 }}>
//                                 <FieldLabel>Numero Conteneur</FieldLabel>
//                                 <Input
//                                     placeholder="Ex: MSKU123456789"
//                                     value={formData.numeroConteneur}
//                                     onChange={(e) => setFormData({ ...formData, numeroConteneur: e.target.value })}
//                                     style={{ ...inputStyle, fontFamily: "'DM Mono', monospace", letterSpacing: "0.5px" }}
//                                 />
//                             </Col>
//                         </Row>
//                     </div>

//                     {/* Poids & Volume */}
//                     <div style={sectionStyle}>
//                         <Text style={sectionLabelStyle}>⚖️ Poids & Volume</Text>
//                         <Row gutter={12}>
//                             <Col span={12}>
//                                 <FieldLabel>Poids (kg)</FieldLabel>
//                                 <Input
//                                     type="number" placeholder="Ex: 12500"
//                                     suffix={<Text type="secondary" style={{ fontSize: 11 }}>kg</Text>}
//                                     value={formData.poids}
//                                     onChange={(e) => setFormData({ ...formData, poids: e.target.value })}
//                                     style={inputStyle}
//                                 />
//                             </Col>
//                             <Col span={12}>
//                                 <FieldLabel>Volume (m³)</FieldLabel>
//                                 <Input
//                                     type="number" placeholder="Ex: 33.2"
//                                     suffix={<Text type="secondary" style={{ fontSize: 11 }}>m³</Text>}
//                                     value={formData.volume}
//                                     onChange={(e) => setFormData({ ...formData, volume: e.target.value })}
//                                     style={inputStyle}
//                                 />
//                             </Col>
//                         </Row>
//                     </div>

//                     {/* Trajet & Client */}
//                     <div style={sectionStyle}>
//                         <Text style={sectionLabelStyle}>🌍 Trajet & Client</Text>
//                         <Row gutter={12}>
//                             <Col span={12}>
//                                 <FieldLabel>Origine</FieldLabel>
//                                 <Select
//                                     style={{ width: "100%" }}
//                                     placeholder="Pays d'origine"
//                                     value={formData.origine || undefined}
//                                     onChange={(v) => setFormData({ ...formData, origine: v })}
//                                     showSearch
//                                 >
//                                     {listeRegion.map((r) => <Option key={r.id} value={r.id}>{r.nom}</Option>)}
//                                 </Select>
//                             </Col>
//                             <Col span={12}>
//                                 <FieldLabel>Destination</FieldLabel>
//                                 <Select
//                                     style={{ width: "100%" }}
//                                     placeholder="Destination"
//                                     value={formData.destination || undefined}
//                                     onChange={(v) => setFormData({ ...formData, destination: v })}
//                                     showSearch
//                                 >
//                                     {listeRegion.map((r) => <Option key={r.id} value={r.id}>{r.nom}</Option>)}
//                                 </Select>
//                             </Col>
//                         </Row>
//                         <Row gutter={12} style={{ marginTop: 12 }}>
//                             <Col span={12}>
//                                 <FieldLabel>Client</FieldLabel>
//                                 <Select
//                                     style={{ width: "100%" }}
//                                     placeholder="Sélectionner un client..."
//                                     value={formData.client || undefined}
//                                     onChange={(v) => setFormData({ ...formData, client: v })}
//                                     showSearch
//                                     optionFilterProp="children"
//                                 >
//                                     {listeClient.map((c) => <Option key={c.id} value={c.id}>{c.nom}</Option>)}
//                                 </Select>
//                             </Col>
//                             <Col span={12}>
//                                 <FieldLabel>Paiement</FieldLabel>
//                                 <Select
//                                     style={{ width: "100%" }}
//                                     value={formData.paiement || undefined}
//                                     onChange={(v) => setFormData({ ...formData, paiement: v })}
//                                 >
//                                     <Option value="Espèce">Espèce</Option>
//                                     <Option value="Virement">Virement</Option>
//                                     <Option value="Chèque">Chèque</Option>
//                                     <Option value="Mobile Money">Mobile Money</Option>
//                                 </Select>
//                             </Col>
//                         </Row>
//                     </div>

//                     <Divider style={{ margin: "16px 0 12px", borderColor: "#e0e3ff" }} />
//                     <Row justify="end" gutter={12}>
//                         <Col>
//                             <Button
//                                 onClick={() => { setCreateModalOpen(false); setFormData(initialFormData); }}
//                                 style={{ borderRadius: 8 }}
//                             >
//                                 Annuler
//                             </Button>
//                         </Col>
//                         <Col>
//                             <Button
//                                 type="primary"
//                                 icon={<PlusOutlined />}
//                                 onClick={handleCreateDossier}
//                                 style={{
//                                     borderRadius: 8,
//                                     background: "linear-gradient(135deg, #6366f1, #4f46e5)",
//                                     border: "none",
//                                     fontWeight: 600,
//                                     padding: "0 20px",
//                                 }}
//                             >
//                                 {isUpdate ? "Mettre à jour" : "Créer le dossier"}
//                             </Button>
//                         </Col>
//                     </Row>
//                 </div>
//             </Modal>

//             {/* ═══ Modal Upload ═══ */}
//             <Modal
//                 title={
//                     <Space>
//                         <div style={{
//                             width: 32, height: 32, borderRadius: 8,
//                             background: "linear-gradient(135deg, #06b6d4, #0891b2)",
//                             display: "flex", alignItems: "center", justifyContent: "center"
//                         }}>
//                             <UploadOutlined style={{ color: "#fff", fontSize: 14 }} />
//                         </div>
//                         <div>
//                             <Text strong style={{ fontFamily: "'DM Sans', sans-serif", color: "#1a1a2e" }}>
//                                 Ajouter un document
//                             </Text>
//                             {selectedDossier && (
//                                 <Text style={{ display: "block", fontSize: 12, color: "#6366f1", fontFamily: "'DM Mono', monospace" }}>
//                                     {selectedDossier.ref}
//                                 </Text>
//                             )}
//                         </div>
//                     </Space>
//                 }
//                 open={uploadModalOpen}
//                 onCancel={() => { setUploadModalOpen(false); setUploadedFile(null); setDenomination(""); }}
//                 footer={null}
//                 width={480}
//                 centered
//             >
//                 <div style={{ marginTop: 16 }}>
//                     <div style={{ marginBottom: 16 }}>
//                         <Text strong style={{ display: "block", marginBottom: 8 }}>Dénomination du document</Text>
//                         <Select
//                             style={{ width: "100%", borderRadius: 8 }}
//                             placeholder="Sélectionner ou saisir la dénomination..."
//                             showSearch
//                             allowClear
//                             value={denomination || undefined}
//                             onChange={(val) => setDenomination(val || "")}
//                             onSearch={(val) => setDenomination(val)}
//                         >
//                             {allDocuments && allDocuments.map(item => (
//                                 <Option key={item.id} value={item.id}>{item.nom}</Option>
//                             ))}
//                         </Select>
//                     </div>
//                     <Text strong style={{ display: "block", marginBottom: 8 }}>Fichier</Text>
//                     <Dragger
//                         beforeUpload={(file) => { setUploadedFile(file); return false; }}
//                         onRemove={() => setUploadedFile(null)}
//                         maxCount={1}
//                         style={{ borderRadius: 12 }}
//                     >
//                         <p className="ant-upload-drag-icon">
//                             <InboxOutlined style={{ color: "#6366f1", fontSize: 36 }} />
//                         </p>
//                         <p style={{ color: "#1a1a2e", fontWeight: 600, margin: "8px 0 4px" }}>
//                             Glissez votre fichier ici
//                         </p>
//                         <p style={{ color: "#9ca3af", fontSize: 12 }}>
//                             PDF, Word, Excel, Image — 20 Mo max
//                         </p>
//                     </Dragger>
//                     {uploadedFile && (
//                         <div style={{
//                             marginTop: 12, padding: "10px 14px", borderRadius: 10,
//                             background: "#f0f1ff", border: "1px solid #c7d2fe",
//                             display: "flex", alignItems: "center", gap: 8,
//                         }}>
//                             <FileTextOutlined style={{ color: "#6366f1" }} />
//                             <Text style={{ fontSize: 13, color: "#4338ca" }}>{uploadedFile.name}</Text>
//                         </div>
//                     )}
//                     <Divider style={{ margin: "16px 0" }} />
//                     <Row justify="end" gutter={12}>
//                         <Col>
//                             <Button
//                                 onClick={() => { setUploadModalOpen(false); setUploadedFile(null); setDenomination(""); }}
//                                 style={{ borderRadius: 8 }}
//                             >
//                                 Annuler
//                             </Button>
//                         </Col>
//                         <Col>
//                             <Button
//                                 type="primary"
//                                 icon={<UploadOutlined />}
//                                 onClick={handleUpload}
//                                 disabled={!uploadedFile || !denomination}
//                                 style={{
//                                     borderRadius: 8,
//                                     background: "linear-gradient(135deg, #06b6d4, #0891b2)",
//                                     border: "none",
//                                     fontWeight: 600,
//                                 }}
//                             >
//                                 Ajouter le document
//                             </Button>
//                         </Col>
//                     </Row>
//                 </div>
//             </Modal>

//             {/* ═══ Modal Changement de statut ═══ */}
//             <Modal
//                 title="Changer le statut du dossier"
//                 open={statusModalOpen}
//                 onCancel={() => setStatusModalOpen(false)}
//                 onOk={handleChangeStatus}
//                 okText="Valider"
//                 cancelText="Annuler"
//             >
//                 <p>Dossier : <strong>{selectedDossier?.ref}</strong></p>
//                 <Select
//                     style={{ width: "100%" }}
//                     placeholder="Choisir un statut"
//                     onChange={(value) => setNewStatus(value)}
//                     options={Object.keys(statusConfig).map((s) => ({ label: s, value: s }))}
//                 />
//             </Modal>

//             {/* ═══ Modal Génération / Modification de devis ═══ */}
//             {devisModalOpen && (
//                 <PrestationModal
//                     open={devisModalOpen}
//                     onClose={() => {
//                         setDevisModalOpen(false);
//                         setdevisInfo(null);
//                     }}
//                 />
//             )}

//             {showToast && <Notification message={notif.message} status={notif.info} />}
//         </div>
//     );
// }


import { useEffect, useState, useMemo, useCallback } from "react";
import {
    Table,
    Button,
    Modal,
    Input,
    Select,
    Tag,
    Space,
    Upload,
    message,
    Tooltip,
    Badge,
    Typography,
    Divider,
    Row,
    Col,
    Empty,
} from "antd";
import Notification from "../../composants/Notification";
import {
    PlusOutlined,
    UploadOutlined,
    FolderOpenOutlined,
    FileTextOutlined,
    ClockCircleOutlined,
    CheckCircleOutlined,
    SyncOutlined,
    ExclamationCircleOutlined,
    InboxOutlined,
    ApartmentOutlined,
    EditOutlined,
    DownloadOutlined,
    SwapOutlined,
    CalculatorOutlined,
    MinusCircleOutlined,
} from "@ant-design/icons";
import { get_ListeClients } from "../../api/clients";
import {
    attachTransitDocument,
    createDevisTransit,
    createDossier,
    downloadTransitDocument,
    getAllCategoriesTransit,
    getAllDossier,
    getAllTransitDocument,
    getDevisTransit,
    getMMarchandises,
    updateDevisTransit,
    updateDossier,
    updateDossierStatus,
} from "../../api/provision";
import { get_ListeRegion } from "../../api/region";
import formatDateFr from "../../utils/utils";

const { Title, Text } = Typography;
const { Option } = Select;
const { Dragger } = Upload;

const STATUS_STYLES = {
    processing: { color: "processing", icon: <SyncOutlined spin />, hex: "#1677ff" },
    warning: { color: "warning", icon: <ClockCircleOutlined />, hex: "#faad14" },
    success: { color: "success", icon: <CheckCircleOutlined />, hex: "#52c41a" },
    error: { color: "error", icon: <ExclamationCircleOutlined />, hex: "#ff4d4f" },
};

const statusConfig = {
    attente_masoandro: { ...STATUS_STYLES.processing, label: "En attente devis" },
    devis_envoyes: { ...STATUS_STYLES.success, label: "Devis envoyé" },
};

const SECTION_KEYS = ["PRESTATION MASOANDRO", "A L'IDENTIQUE"];

const inputStyle = { borderRadius: 8, height: 36 };
const sectionStyle = {
    background: "#fafbff",
    border: "1px solid #eef0ff",
    borderRadius: 12,
    padding: "14px 16px",
    marginBottom: 12,
};
const sectionLabelStyle = {
    display: "block",
    fontWeight: 700,
    fontSize: 12,
    color: "#6366f1",
    textTransform: "uppercase",
    letterSpacing: "0.6px",
    marginBottom: 10,
};

const FieldLabel = ({ children }) => (
    <Text style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 4 }}>
        {children}
    </Text>
);

// ─────────────────────────────────────────────────────────────────────────────
// SectionBlock : composant autonome (ligne d'une prestation dans une section)
// Sorti au niveau module pour ne jamais être redéfini pendant le render du parent.
// ─────────────────────────────────────────────────────────────────────────────
function SectionBlock({
    sectionKey,
    lines,
    accentColor,
    canEdit,
    listeCategories,
    onAddLine,
    onChangeLine,
    onRemoveLine,
}) {
    return (
        <div style={{ marginBottom: 24 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
                <Space size={8}>
                    <span style={{ width: 8, height: 8, borderRadius: "50%", background: accentColor, display: "inline-block" }} />
                    <Text strong style={{ fontSize: 13, letterSpacing: "0.02em" }}>{sectionKey}</Text>
                    <Tag color={accentColor} style={{ borderRadius: 10, fontSize: 11 }}>
                        {lines.length} ligne{lines.length > 1 ? "s" : ""}
                    </Tag>
                </Space>
                {canEdit && (
                    <Button
                        size="small"
                        icon={<PlusOutlined />}
                        onClick={() => onAddLine(sectionKey)}
                        style={{ borderRadius: 6, fontSize: 12 }}
                    >
                        Ajouter
                    </Button>
                )}
            </div>

            {lines.length > 0 && (
                <Row gutter={8} style={{ padding: "0 4px", marginBottom: 4 }}>
                    <Col flex="auto"><Text type="secondary" style={{ fontSize: 11 }}>Prestation</Text></Col>
                    <Col style={{ width: 150 }}><Text type="secondary" style={{ fontSize: 11 }}>Prix (Ar)</Text></Col>
                    {canEdit && <Col style={{ width: 32 }} />}
                </Row>
            )}

            {lines.length === 0 ? (
                <Empty description="Aucune ligne" image={Empty.PRESENTED_IMAGE_SIMPLE} style={{ margin: "12px 0" }} />
            ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                    {lines.map((line) => (
                        <Row
                            key={line.key}
                            gutter={8}
                            align="middle"
                            style={{ background: "#f5f5f5", borderRadius: 8, padding: "6px 10px" }}
                        >
                            <Col flex="auto">
                                <Select
                                    size="small"
                                    value={line.nom}
                                    style={{ width: "100%" }}
                                    disabled={!canEdit}
                                    onChange={(val) => onChangeLine(sectionKey, line.key, "nom", val)}
                                    options={(listeCategories[sectionKey] || []).map((p) => ({ label: p.nom, value: p.nom }))}
                                />
                            </Col>
                            <Col style={{ width: 150 }}>
                                <Input
                                    size="small"
                                    style={{ width: "100%" }}
                                    value={line.prix}
                                    disabled={!canEdit}
                                    onChange={(e) => onChangeLine(sectionKey, line.key, "prix", e.target.value)}
                                />
                            </Col>
                            {canEdit && (
                                <Col style={{ width: 32 }}>
                                    <Button
                                        danger
                                        size="small"
                                        icon={<MinusCircleOutlined />}
                                        shape="default"
                                        style={{ borderRadius: 6, width: 28, padding: 0 }}
                                        onClick={() => onRemoveLine(sectionKey, line.key)}
                                    />
                                </Col>
                            )}
                        </Row>
                    ))}
                </div>
            )}
        </div>
    );
}

// ─────────────────────────────────────────────────────────────────────────────
// PrestationModal : composant autonome, sorti de Dossier().
// Tout ce dont il a besoin arrive en props ; c'est un vrai composant React,
// donc tous ses hooks internes (useState/useEffect/useCallback) sont légaux.
// ─────────────────────────────────────────────────────────────────────────────
function PrestationModal({
    open,
    onClose,
    selectedDossier,
    devisInfo,
    listeCategories,
    buildEmptyLine,
    computeTotal,
    mapDevisToLines,
    onSubmit,
}) {
    const [prestationLines, setPrestationLines] = useState(
        SECTION_KEYS.reduce((acc, k) => ({ ...acc, [k]: [] }), {})
    );

    const hasDevis = !!selectedDossier?.devis_id;
    const canEdit = !hasDevis || devisInfo?.devis_statut !== "validaté";

    // Initialisation des lignes à l'ouverture du modal
    useEffect(() => {
        if (!open) return;

        if (hasDevis && devisInfo?.devis_infos?.length) {
            const mapped = mapDevisToLines(devisInfo.devis_infos, listeCategories, SECTION_KEYS);
            setPrestationLines(mapped);
        } else {
            setPrestationLines(SECTION_KEYS.reduce((acc, k) => ({ ...acc, [k]: [] }), {}));
        }
    }, [open, hasDevis, devisInfo, listeCategories, mapDevisToLines]);

    const handleAddLine = useCallback((section) => {
        setPrestationLines((prev) => ({
            ...prev,
            [section]: [...prev[section], buildEmptyLine(section)],
        }));
    }, [buildEmptyLine]);

    const handleRemoveLine = useCallback((section, key) => {
        setPrestationLines((prev) => ({
            ...prev,
            [section]: prev[section].filter((l) => l.key !== key),
        }));
    }, []);

    const handleChangeLine = useCallback((section, key, field, value) => {
        setPrestationLines((prev) => {
            const newLines = { ...prev };
            newLines[section] = prev[section].map((l) => {
                if (l.key !== key) return l;
                if (field === "nom") {
                    const found = listeCategories[section]?.find((p) => p.nom === value);
                    return {
                        ...l,
                        nom: value,
                        categorie_id: found?.categorie_id ?? l.categorie_id
                    };
                }
                return { ...l, [field]: value };
            });
            return newLines;
        });
    }, [listeCategories]);

    const total = computeTotal(prestationLines);

    const handleClose = useCallback(() => {
        setPrestationLines(SECTION_KEYS.reduce((acc, k) => ({ ...acc, [k]: [] }), {}));
        onClose();
    }, [onClose]);

    const handleSubmitPrestation = async () => {
        const isUpdating = hasDevis && devisInfo?.devis_statut !== "validate";
        const payload = Object.entries(prestationLines).flatMap(([section, lines]) =>
            lines.map(({ categorie_id, nom, prix }) => ({
                section,
                categorie_id,
                nom,
                prix: Number(prix),
                dossier_id: selectedDossier?.id,
                ...(isUpdating && { devis_id: selectedDossier?.devis_id }),
            }))
        );

        await onSubmit(payload, isUpdating);
        handleClose();
    };

    return (
        <Modal
            open={open}
            onCancel={handleClose}
            title={
                <div>
                    <div style={{ fontWeight: 500, fontSize: 16 }}>
                        {hasDevis ? "Devis existant" : "Générer un devis"}
                        {selectedDossier && (
                            <span style={{ marginLeft: 8, fontSize: 13, color: "#6366f1", fontFamily: "'DM Mono', monospace" }}>
                                — {selectedDossier.ref}
                            </span>
                        )}
                    </div>
                    <div style={{ fontWeight: 400, fontSize: 13, color: "#8c8c8c" }}>
                        {hasDevis
                            ? canEdit
                                ? "Vous pouvez modifier ce devis (dossier validé)"
                                : "Consultation uniquement — le dossier doit être validé pour modifier"
                            : "Ajoutez les lignes de prestation selon vos besoins"}
                    </div>
                </div>
            }
            footer={
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Text type="secondary" style={{ fontSize: 13 }}>
                        Total :{" "}
                        <Text strong style={{ fontSize: 15 }}>
                            {total.toLocaleString("fr-MG")} Ar
                        </Text>
                    </Text>
                    <Space>
                        <Button onClick={handleClose}>
                            {canEdit ? "Annuler" : "Fermer"}
                        </Button>
                        {canEdit && (
                            <Button
                                type="primary"
                                onClick={handleSubmitPrestation}
                                style={{
                                    background: "linear-gradient(135deg, #6366f1, #4f46e5)",
                                    border: "none",
                                    borderRadius: 8,
                                    fontWeight: 600,
                                }}
                            >
                                {hasDevis ? "Modifier le devis" : "Enregistrer le devis"}
                            </Button>
                        )}
                    </Space>
                </div>
            }
            width={600}
            styles={{ body: { maxHeight: "60vh", overflowY: "auto", padding: "20px 24px" } }}
        >
            {hasDevis && !canEdit && (
                <div style={{
                    background: "#fff7e6",
                    border: "1px solid #ffd591",
                    borderRadius: 8,
                    padding: "8px 14px",
                    marginBottom: 16,
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    fontSize: 13,
                    color: "#d46b08",
                }}>
                    <ExclamationCircleOutlined />
                    <span>La modification du devis est réservée aux dossiers avec le statut <strong>validé</strong>.</span>
                </div>
            )}

            <SectionBlock
                sectionKey="PRESTATION MASOANDRO"
                lines={prestationLines["PRESTATION MASOANDRO"]}
                accentColor="#185FA5"
                canEdit={canEdit}
                listeCategories={listeCategories}
                onAddLine={handleAddLine}
                onChangeLine={handleChangeLine}
                onRemoveLine={handleRemoveLine}
            />

            <Divider style={{ margin: "4px 0 20px" }} />

            <SectionBlock
                sectionKey="A L'IDENTIQUE"
                lines={prestationLines["A L'IDENTIQUE"]}
                accentColor="#3B6D11"
                canEdit={canEdit}
                listeCategories={listeCategories}
                onAddLine={handleAddLine}
                onChangeLine={handleChangeLine}
                onRemoveLine={handleRemoveLine}
            />
        </Modal>
    );
}

// ─────────────────────────────────────────────────────────────────────────────
// Composant principal
// ─────────────────────────────────────────────────────────────────────────────
export default function Dossier() {
    const initialFormData = {
        id: null,
        typeMarchandise: "",
        marchandises: "",
        typeConteneur: "",
        nbConteneur: "",
        numeroConteneur: "",
        nbColis: 0,
        poids: "",
        volume: "",
        origine: "",
        destination: "",
        client: "",
        referenceBL: "",
        paiement: "Espece",
    };

    // ─── State ─────────────────────────────────────────────────────────────────
    const [allDocuments, setallDocuments] = useState([]);
    const [dossiers, setDossiers] = useState([]);
    const [isUpdate, setIsUpdate] = useState(false);
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [uploadModalOpen, setUploadModalOpen] = useState(false);
    const [devisModalOpen, setDevisModalOpen] = useState(false);
    const [selectedDossier, setSelectedDossier] = useState(null);
    const [uploadedFile, setUploadedFile] = useState(null);
    const [denomination, setDenomination] = useState("");
    const [formData, setFormData] = useState(initialFormData);
    const [listeClient, setListeClients] = useState([]);
    const [allMarchandises, setAllMarchandises] = useState([]);
    const [listeRegion, setlisteRegion] = useState([]);
    const [showToast, setshowToast] = useState(false);
    const [notif, setnotif] = useState({ message: null, info: null });
    const [loading, setLoading] = useState(false);
    const [listeCategories, setlisteCategories] = useState({});
    const [statusModalOpen, setStatusModalOpen] = useState(false);
    const [newStatus, setNewStatus] = useState(null);
    const [devisInfo, setdevisInfo] = useState(null);

    // ─── Helpers partagés mémorisés ─────────────────────────────────────────────
    const buildEmptyLine = useCallback((section) => {
        const firstItem = listeCategories[section]?.[0];
        return {
            key: Date.now() + Math.random(),
            categorie_id: firstItem?.categorie_id ?? null,
            nom: firstItem?.nom ?? "",
            prix: 0,
        };
    }, [listeCategories]);

    const computeTotal = useCallback((lines) => {
        return Object.values(lines)
            .flat()
            .reduce((sum, l) => sum + (Number(l.prix) || 0), 0);
    }, []);

    const mapDevisToLines = useCallback((devisInfos, prestationsData, sectionKeys) => {
        const result = sectionKeys.reduce((acc, key) => {
            acc[key] = [];
            return acc;
        }, {});

        devisInfos.forEach((item) => {
            for (const section of sectionKeys) {
                const found = prestationsData[section]?.find(
                    (p) => p.categorie_id === item.categorie_id
                );
                if (found) {
                    result[section].push({
                        key: Date.now() + Math.random(),
                        categorie_id: item.categorie_id,
                        nom: found.nom,
                        prix: item.montant,
                    });
                    break;
                }
            }
        });

        return result;
    }, []);

    // ─── Soumission du devis (appel API) ────────────────────────────────────────
    const handleSubmitPrestation = useCallback(async (payload, isUpdating) => {
        const res = isUpdating
            ? await updateDevisTransit(payload)
            : await createDevisTransit(payload);

        const mess = isUpdating ? "Devis mis à jour avec succès !!!" : "Devis généré avec succès !!!";
        const mess_error = isUpdating ? "Erreur mise à jour devis !!!" : "Erreur génération !!!";

        if (res.status === "success") {
            setnotif({ message: mess, info: "success" });
            setshowToast(true);
            setTimeout(() => { window.location.reload(); }, 1500);
        } else {
            message.warning(mess_error);
            setnotif({ message: mess_error, info: "error" });
            setshowToast(true);
            setTimeout(() => { setshowToast(false); }, 1500);
        }
    }, []);

    // ─── Data fetching ─────────────────────────────────────────────────────────
    useEffect(() => {
        fetchAllCategorie();
        fetchAllTypeDocument();
        fetchListeClients();
        fetchMarchandise();
        fetchListeRegion();
        fetchAllDossier();
    }, []);

    const fetchAllDossier = async () => {
        setLoading(true);
        const res = await getAllDossier();
        setDossiers(res.data);
        setLoading(false);
    };

    const fetchAllCategorie = async () => {
        setLoading(true);
        const res = await getAllCategoriesTransit();
        const categories = res.data;
        const grouped = categories.reduce((acc, item) => {
            if (!acc[item.type]) acc[item.type] = [];
            acc[item.type].push({ categorie_id: item.id, nom: item.nom, prix: 0 });
            return acc;
        }, {});
        setlisteCategories(grouped);
        setLoading(false);
    };

    const fetchListeClients = async () => {
        const res = await get_ListeClients();
        setListeClients(res.data);
    };

    const fetchAllTypeDocument = async () => {
        const res = await getAllTransitDocument();
        setallDocuments(res.data);
    };

    const fetchListeRegion = async () => {
        const res = await get_ListeRegion();
        setlisteRegion(res.data);
    };

    const fetchMarchandise = async () => {
        try {
            const res = await getMMarchandises();
            setAllMarchandises(res.data || []);
        } catch (error) {
            message.error("Erreur lors de la récupération des marchandises");
        }
    };

    const fetchDevisInfo = async (dossier) => {
        try {
            const res = await getDevisTransit({
                devis_id: dossier?.devis_id,
                dossier_id: dossier?.id,
            });

            const data = res?.data || [];
            if (!data.length) {
                setdevisInfo(null);
                return;
            }

            const devis = data[0];
            let devisInfosParsed = [];
            try {
                devisInfosParsed = devis.devis_infos ? JSON.parse(devis.devis_infos) : [];
            } catch (e) {
                console.warn("Erreur parsing devis_infos", e);
            }

            setdevisInfo({ ...devis, devis_infos: devisInfosParsed });
        } catch (error) {
            console.error(error);
            message.error("Erreur lors de la récupération du devis");
        }
    };

    // ─── Handlers ──────────────────────────────────────────────────────────────
    const handleCreateDossier = async () => {
        if (!formData.marchandises || !formData.typeMarchandise || !formData.origine || !formData.destination || !formData.client) {
            message.warning("Veuillez remplir les champs obligatoires : marchandises, origine, destination, client.");
            return;
        }

        const newDossier = {
            id: formData.id,
            marchandise_id: formData.typeMarchandise,
            marchandise: formData.marchandises,
            region_depart_id: formData.origine,
            region_destination_id: formData.destination,
            client_id: formData.client,
            ref_bl: formData.referenceBL,
            type_conteneur: formData.typeConteneur,
            nb_conteneur: formData.nbConteneur,
            numero_conteneur: formData.numeroConteneur,
            nb_colis: formData.nbColis,
            poids: formData.poids,
            volume: formData.volume,
            paiement: formData.paiement,
        };

        let res = null;
        if (isUpdate) {
            res = await updateDossier(newDossier);
        } else {
            res = await createDossier(newDossier);
        }

        const mess = isUpdate ? "Dossier mis à jour avec succés" : "Dossier generé avec succés";
        const mess_error = isUpdate ? "Erreur mise à jour Dossier !!!" : "Erreur creation Dossier !!!";

        if (res.status === "success") {
            setnotif({ message: mess, info: "success" });
            setshowToast(true);
            setTimeout(() => { window.location.reload(); }, 1500);
        } else {
            message.warning(mess_error);
            setnotif({ message: mess_error, info: "error" });
            setshowToast(true);
            setTimeout(() => { setshowToast(false); }, 1500);
        }
    };

    const handleUpload = async () => {
        if (!uploadedFile || !denomination) {
            message.warning("Veuillez sélectionner un fichier et renseigner sa dénomination.");
            return;
        }

        const fd = new FormData();
        fd.append("file", uploadedFile);
        fd.append("tr_dossier_id", selectedDossier.id);
        fd.append("tr_document_id", denomination);

        try {
            const res = await attachTransitDocument(fd);
            const mess = "File uploadé avec succès !!!";
            const mess_error = "Erreur upload !!!";
            if (res.status === "success") {
                setnotif({ message: mess, info: "success" });
                setshowToast(true);
                setTimeout(() => { window.location.reload(); }, 1500);
            } else {
                message.warning(mess_error);
                setnotif({ message: mess_error, info: "error" });
                setshowToast(true);
                setTimeout(() => { setshowToast(false); }, 1500);
            }
        } catch (err) {
            console.error(err);
            message.error("Erreur upload");
        }

        setUploadModalOpen(false);
        setUploadedFile(null);
        setDenomination("");
    };

    const handleDownload = async (id) => {
        try {
            const res = await downloadTransitDocument(id);
            const blob = new Blob([res.data], { type: "application/zip" });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `dossier_${id}.zip`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            setnotif({ message: "Téléchargement réussi ✅", info: "success" });
            setshowToast(true);
            setTimeout(() => { setshowToast(false); }, 1500);
        } catch (error) {
            console.error(error);
            setnotif({ message: "Erreur lors du téléchargement ❌", info: "error" });
            setshowToast(true);
            setTimeout(() => { setshowToast(false); }, 1500);
        }
    };

    const onClickEditDossier = (record) => {
        setIsUpdate(true);
        setFormData({
            id: record.id,
            typeMarchandise: record.marchandise_id,
            marchandises: record.marchandise,
            typeConteneur: record.type_conteneur,
            nbConteneur: record.nb_conteneur,
            numeroConteneur: record.numero_conteneur,
            nbColis: record.nbColis,
            poids: record.poids,
            volume: record.volume,
            origine: record.region_depart_id,
            destination: record.region_destination_id,
            client: record.client_id,
            referenceBL: record.ref_bl,
            paiement: record.paiement,
        });
        setCreateModalOpen(true);
    };

    const onGenerateDevis = async (record) => {
        setdevisInfo(null);
        setSelectedDossier(record);
        if (record.devis_id) {
            await fetchDevisInfo(record);
        }
        setDevisModalOpen(true);
    };

    const handleChangeStatus = async () => {
        if (!newStatus || !selectedDossier) return;
        const res = await updateDossierStatus(selectedDossier.id, newStatus);
        const mess = res.description;
        const mess_error = "Erreur lors du changement de statut";

        if (res.status === "success") {
            setnotif({ message: mess, info: "success" });
            setshowToast(true);
            setTimeout(() => { window.location.reload(); }, 1500);
        } else {
            message.warning(mess_error);
            setnotif({ message: mess_error, info: "error" });
            setshowToast(true);
            setTimeout(() => { setshowToast(false); }, 1500);
        }
    };

    // ─── Columns ───────────────────────────────────────────────────────────────
    const columns = useMemo(() => {
        if (!listeClient.length || !listeRegion.length || !allMarchandises.length) {
            return [];
        }

        return [
            {
                title: "ID",
                dataIndex: "id",
                key: "id",
                width: 50,
                align: "center",
                render: (text) => (
                    <Text strong style={{ color: "#1a1a2e", fontFamily: "'DM Mono', monospace", fontSize: 13 }}>
                        {text}
                    </Text>
                ),
            },
            {
                title: "Date creation",
                dataIndex: "create_at",
                key: "create_at",
                width: 150,
                align: "center",
                render: (text) => (
                    <Text strong style={{ color: "#1a1a2e", fontFamily: "'DM Mono', monospace", fontSize: 13 }}>
                        {formatDateFr(text)}
                    </Text>
                ),
            },
            {
                title: "Réference",
                dataIndex: "ref",
                key: "ref",
                width: 200,
                align: "center",
                ellipsis: true,
                render: (text) => (
                    <Space>
                        <FolderOpenOutlined style={{ color: "#6366f1" }} />
                        <Text style={{ fontSize: 13 }}>{text}</Text>
                    </Space>
                ),
            },
            {
                title: "Client",
                key: "client_id",
                align: "center",
                width: 160,
                render: (_, r) => {
                    const client = listeClient.find(c => c.id === r.client_id);
                    return <strong style={{ fontSize: 13 }}>{client?.nom ?? "—"}</strong>;
                },
                filters: listeClient.map(c => ({ text: c.nom, value: c.id })),
                onFilter: (value, record) => record.client_id === value,
            },
            {
                title: "Trajet",
                key: "trajet",
                width: 160,
                align: "center",
                render: (_, r) => {
                    const regionDepart = listeRegion.find(reg => reg.id === r.region_depart_id);
                    const regionArrive = listeRegion.find(reg => reg.id === r.region_destination_id);
                    return <span style={{ fontSize: 13 }}>{regionDepart?.nom ?? "?"} ➜ {regionArrive?.nom ?? "?"}</span>;
                },
                filters: listeRegion.map(r => ({ text: r.nom, value: r.id })),
                onFilter: (value, record) =>
                    record.region_depart_id === value || record.region_destination_id === value,
            },
            {
                title: "Marchandises",
                key: "marchandise",
                width: 150,
                align: "center",
                render: (_, r) => {
                    const marchandise = allMarchandises.find(m => m.id === r.marchandise_id);
                    return (
                        <>
                            <span style={{ fontSize: 13 }}>{r.marchandise}</span>
                            <br />
                            <span style={{ fontSize: 11 }}>({marchandise?.nom ?? "N/A"})</span>
                        </>
                    );
                },
                filters: allMarchandises.map(m => ({ text: m.nom, value: m.id })),
                onFilter: (value, record) => record.marchandise_id === value,
            },
            {
                title: "Statut",
                dataIndex: "statut",
                key: "statut",
                align: "center",
                width: 140,
                render: (statut) => {
                    const cfg = statusConfig?.[statut];
                    if (!cfg) {
                        return <Badge status="default" text={<Text style={{ fontSize: 13 }}>{statut || "Inconnu"}</Text>} />;
                    }
                    return (
                        <Badge
                            status={cfg.color}
                            text={
                                <Text style={{ fontSize: 13, color: cfg.hex, fontWeight: 500 }}>
                                    {cfg.icon} {statut}
                                </Text>
                            }
                        />
                    );
                },
                filters: Object.keys(statusConfig).map((s) => ({ text: s, value: s })),
                onFilter: (value, record) => record.statut === value,
            },
            {
                title: "Action",
                key: "action",
                width: 220,
                fixed: 'right',
                align: "center",
                render: (_, record) => (
                    <Space size="middle">
                        <Tooltip title="Changer le statut">
                            <Button
                                shape="circle"
                                icon={<SwapOutlined />}
                                style={{ background: "#f59e0b", border: "none", color: "#fff", boxShadow: "0 2px 6px rgba(245,158,11,0.3)" }}
                                onClick={() => { setSelectedDossier(record); setStatusModalOpen(true); }}
                            />
                        </Tooltip>

                        <Tooltip title="Modifier le dossier">
                            <Button
                                shape="circle"
                                icon={<EditOutlined />}
                                style={{ background: "#3b82f6", border: "none", color: "#fff", boxShadow: "0 2px 6px rgba(59,130,246,0.3)" }}
                                onMouseEnter={(e) => { e.currentTarget.style.background = "#2563eb"; }}
                                onMouseLeave={(e) => { e.currentTarget.style.background = "#3b82f6"; }}
                                onClick={() => onClickEditDossier(record)}
                            />
                        </Tooltip>

                        <Tooltip title={record.devis_id ? "Voir / Modifier le devis" : "Générer devis"}>
                            <Button
                                shape="circle"
                                icon={<CalculatorOutlined />}
                                style={{ background: "#8b5cf6", border: "none", color: "#fff", boxShadow: "0 2px 6px rgba(139,92,246,0.3)" }}
                                onMouseEnter={(e) => { e.currentTarget.style.background = "#7c3aed"; }}
                                onMouseLeave={(e) => { e.currentTarget.style.background = "#8b5cf6"; }}
                                onClick={() => onGenerateDevis(record)}
                            />
                        </Tooltip>

                        <Tooltip title="Ajouter un document">
                            <Button
                                type="primary"
                                shape="circle"
                                icon={<UploadOutlined />}
                                style={{ background: "#6366f1", border: "none", boxShadow: "0 2px 6px rgba(99,102,241,0.3)" }}
                                onClick={() => { setSelectedDossier(record); setUploadModalOpen(true); }}
                            />
                        </Tooltip>

                        <Tooltip title="Télécharger les documents">
                            <Button
                                type="primary"
                                shape="circle"
                                icon={<DownloadOutlined />}
                                style={{ background: "#10b981", border: "none", boxShadow: "0 2px 6px rgba(16,185,129,0.3)" }}
                                onMouseEnter={(e) => { e.currentTarget.style.background = "#059669"; }}
                                onMouseLeave={(e) => { e.currentTarget.style.background = "#10b981"; }}
                                onClick={() => handleDownload(record.id)}
                            />
                        </Tooltip>
                    </Space>
                ),
            },
        ];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listeClient, listeRegion, allMarchandises]);

    // ─── Render ────────────────────────────────────────────────────────────────
    return (
        <div style={{ minHeight: "100vh", background: "#f8f9fe", padding: "32px 28px", fontFamily: "'DM Sans', sans-serif", width: "100%" }}>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=DM+Mono:wght@400;500&display=swap');
                .dossier-table {
                    height: 100%;
                    overflow: auto;
                }
                .dossier-table .ant-table-thead > tr > th {
                    background: #f1f3ff !important; color: #4338ca !important; font-weight: 600 !important;
                    font-size: 12px !important; text-transform: uppercase; letter-spacing: 0.5px;
                    border-bottom: 2px solid #e0e3ff !important;
                }
                .dossier-table .ant-table-row:hover > td { background: #fafaff !important; }
                .dossier-table .ant-table-row > td { border-bottom: 1px solid #f0f0f8 !important; transition: background 0.2s; }
                .stat-card { border-radius: 16px !important; border: 1.5px solid #ece9ff !important; transition: box-shadow 0.2s, transform 0.2s; }
                .stat-card:hover { box-shadow: 0 8px 24px rgba(99,102,241,0.10) !important; transform: translateY(-2px); }
                .create-btn {
                    background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%) !important; border: none !important;
                    border-radius: 10px !important; height: 40px !important; font-weight: 600 !important;
                    box-shadow: 0 4px 14px rgba(99,102,241,0.35) !important; transition: box-shadow 0.2s, transform 0.2s !important;
                }
                .create-btn:hover { box-shadow: 0 6px 20px rgba(99,102,241,0.45) !important; transform: translateY(-1px); }
                .ant-modal-content { border-radius: 18px !important; }
                .ant-upload-drag { border-radius: 12px !important; border-color: #c7d2fe !important; }
                .ant-upload-drag:hover { border-color: #6366f1 !important; }
            `}</style>

            {/* Header */}
            <div style={{ marginBottom: 28 }}>
                <Row justify="space-between" align="middle">
                    <Col>
                        <Space align="center">
                            <div style={{
                                width: 44, height: 44, borderRadius: 12,
                                background: "linear-gradient(135deg, #6366f1, #4f46e5)",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                boxShadow: "0 4px 12px rgba(99,102,241,0.3)"
                            }}>
                                <ApartmentOutlined style={{ fontSize: 22, color: "#fff" }} />
                            </div>
                            <div>
                                <Title level={3} style={{ margin: 0, color: "#1a1a2e", fontFamily: "'DM Sans', sans-serif", fontWeight: 700 }}>
                                    Gestion des Dossiers Transit
                                </Title>
                                <Text type="secondary" style={{ fontSize: 13 }}>
                                    Suivi et gestion des opérations de transit international
                                </Text>
                            </div>
                        </Space>
                    </Col>
                    <Col>
                        <Button
                            className="create-btn"
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={() => { setIsUpdate(false); setFormData(initialFormData); setCreateModalOpen(true); }}
                        >
                            Nouveau Dossier Transit
                        </Button>
                    </Col>
                </Row>
            </div>

            {/* Table */}
            <Table
                className="dossier-table"
                dataSource={dossiers}
                columns={columns}
                rowKey="id"
                loading={{ spinning: loading, tip: "Chargement des dossiers..." }}
                pagination={{ pageSize: 4, showSizeChanger: false, style: { padding: "12px 20px" } }}
                size="middle"
                style={{ borderRadius: 18 }}
                scroll={{ x: "max-content" }}
                locale={{ emptyText: "Aucun dossier trouvé" }}
            />

            {/* ═══ Modal Création / Modification ═══ */}
            <Modal
                title={
                    <Space>
                        <div style={{
                            width: 32, height: 32, borderRadius: 8,
                            background: "linear-gradient(135deg, #6366f1, #4f46e5)",
                            display: "flex", alignItems: "center", justifyContent: "center"
                        }}>
                            <PlusOutlined style={{ color: "#fff", fontSize: 14 }} />
                        </div>
                        <span style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 700, color: "#1a1a2e" }}>
                            {isUpdate ? "Mise à jour Dossier Transit" : "Nouveau Dossier Transit"}
                        </span>
                    </Space>
                }
                open={createModalOpen}
                onCancel={() => { setCreateModalOpen(false); setFormData(initialFormData); }}
                footer={null}
                width={680}
                centered
            >
                <div style={{ marginTop: 8 }}>
                    {/* Marchandises */}
                    <div style={sectionStyle}>
                        <Text style={sectionLabelStyle}>📦 Marchandises</Text>
                        <Row gutter={12}>
                            <Col span={12}>
                                <FieldLabel>Type de marchandises</FieldLabel>
                                <Select
                                    style={{ width: "100%" }}
                                    placeholder="Sélectionner..."
                                    value={formData.typeMarchandise || undefined}
                                    onChange={(v) => setFormData({ ...formData, typeMarchandise: v })}
                                    showSearch
                                >
                                    {allMarchandises.map((item) => (
                                        <Option key={item.id} value={item.id}>{item.nom}</Option>
                                    ))}
                                </Select>
                            </Col>
                            <Col span={12}>
                                <FieldLabel>Marchandises</FieldLabel>
                                <Input
                                    placeholder="Description des marchandises"
                                    value={formData.marchandises}
                                    onChange={(e) => setFormData({ ...formData, marchandises: e.target.value })}
                                    style={inputStyle}
                                />
                            </Col>
                        </Row>
                    </div>

                    {/* Conteneurisation */}
                    <div style={sectionStyle}>
                        <Text style={sectionLabelStyle}>🚢 Conteneurisation</Text>
                        <Row gutter={12}>
                            <Col span={8}>
                                <FieldLabel>Type de conteneur</FieldLabel>
                                <Select
                                    style={{ width: "100%" }}
                                    placeholder="Sélectionner..."
                                    value={formData.typeConteneur || undefined}
                                    onChange={(v) => setFormData({ ...formData, typeConteneur: v })}
                                >
                                    <Option value="20 pieds">20 pieds</Option>
                                    <Option value="40 pieds">40 pieds</Option>
                                </Select>
                            </Col>
                            <Col span={8}>
                                <FieldLabel>Nombre de conteneurs</FieldLabel>
                                <Input
                                    type="number" min={1} placeholder="Ex: 2"
                                    value={formData.nbConteneur}
                                    onChange={(e) => setFormData({ ...formData, nbConteneur: e.target.value })}
                                    style={inputStyle}
                                />
                            </Col>
                            <Col span={8}>
                                <FieldLabel>Nombre de colis</FieldLabel>
                                <Input
                                    type="number" min={1} placeholder="Ex: 2"
                                    value={formData.nbColis}
                                    onChange={(e) => setFormData({ ...formData, nbColis: e.target.value })}
                                    style={inputStyle}
                                />
                            </Col>
                            <Col span={8} style={{ marginTop: 12 }}>
                                <FieldLabel>Référence BL</FieldLabel>
                                <Input
                                    placeholder="Ex: MSKU123456789"
                                    value={formData.referenceBL}
                                    onChange={(e) => setFormData({ ...formData, referenceBL: e.target.value })}
                                    style={{ ...inputStyle, fontFamily: "'DM Mono', monospace", letterSpacing: "0.5px" }}
                                />
                            </Col>
                            <Col span={8} style={{ marginTop: 12 }}>
                                <FieldLabel>Numero Conteneur</FieldLabel>
                                <Input
                                    placeholder="Ex: MSKU123456789"
                                    value={formData.numeroConteneur}
                                    onChange={(e) => setFormData({ ...formData, numeroConteneur: e.target.value })}
                                    style={{ ...inputStyle, fontFamily: "'DM Mono', monospace", letterSpacing: "0.5px" }}
                                />
                            </Col>
                        </Row>
                    </div>

                    {/* Poids & Volume */}
                    <div style={sectionStyle}>
                        <Text style={sectionLabelStyle}>⚖️ Poids & Volume</Text>
                        <Row gutter={12}>
                            <Col span={12}>
                                <FieldLabel>Poids (kg)</FieldLabel>
                                <Input
                                    type="number" placeholder="Ex: 12500"
                                    suffix={<Text type="secondary" style={{ fontSize: 11 }}>kg</Text>}
                                    value={formData.poids}
                                    onChange={(e) => setFormData({ ...formData, poids: e.target.value })}
                                    style={inputStyle}
                                />
                            </Col>
                            <Col span={12}>
                                <FieldLabel>Volume (m³)</FieldLabel>
                                <Input
                                    type="number" placeholder="Ex: 33.2"
                                    suffix={<Text type="secondary" style={{ fontSize: 11 }}>m³</Text>}
                                    value={formData.volume}
                                    onChange={(e) => setFormData({ ...formData, volume: e.target.value })}
                                    style={inputStyle}
                                />
                            </Col>
                        </Row>
                    </div>

                    {/* Trajet & Client */}
                    <div style={sectionStyle}>
                        <Text style={sectionLabelStyle}>🌍 Trajet & Client</Text>
                        <Row gutter={12}>
                            <Col span={12}>
                                <FieldLabel>Origine</FieldLabel>
                                <Select
                                    style={{ width: "100%" }}
                                    placeholder="Pays d'origine"
                                    value={formData.origine || undefined}
                                    onChange={(v) => setFormData({ ...formData, origine: v })}
                                    showSearch
                                >
                                    {listeRegion.map((r) => <Option key={r.id} value={r.id}>{r.nom}</Option>)}
                                </Select>
                            </Col>
                            <Col span={12}>
                                <FieldLabel>Destination</FieldLabel>
                                <Select
                                    style={{ width: "100%" }}
                                    placeholder="Destination"
                                    value={formData.destination || undefined}
                                    onChange={(v) => setFormData({ ...formData, destination: v })}
                                    showSearch
                                >
                                    {listeRegion.map((r) => <Option key={r.id} value={r.id}>{r.nom}</Option>)}
                                </Select>
                            </Col>
                        </Row>
                        <Row gutter={12} style={{ marginTop: 12 }}>
                            <Col span={12}>
                                <FieldLabel>Client</FieldLabel>
                                <Select
                                    style={{ width: "100%" }}
                                    placeholder="Sélectionner un client..."
                                    value={formData.client || undefined}
                                    onChange={(v) => setFormData({ ...formData, client: v })}
                                    showSearch
                                    optionFilterProp="children"
                                >
                                    {listeClient.map((c) => <Option key={c.id} value={c.id}>{c.nom}</Option>)}
                                </Select>
                            </Col>
                            <Col span={12}>
                                <FieldLabel>Paiement</FieldLabel>
                                <Select
                                    style={{ width: "100%" }}
                                    value={formData.paiement || undefined}
                                    onChange={(v) => setFormData({ ...formData, paiement: v })}
                                >
                                    <Option value="Espèce">Espèce</Option>
                                    <Option value="Virement">Virement</Option>
                                    <Option value="Chèque">Chèque</Option>
                                    <Option value="Mobile Money">Mobile Money</Option>
                                </Select>
                            </Col>
                        </Row>
                    </div>

                    <Divider style={{ margin: "16px 0 12px", borderColor: "#e0e3ff" }} />
                    <Row justify="end" gutter={12}>
                        <Col>
                            <Button
                                onClick={() => { setCreateModalOpen(false); setFormData(initialFormData); }}
                                style={{ borderRadius: 8 }}
                            >
                                Annuler
                            </Button>
                        </Col>
                        <Col>
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={handleCreateDossier}
                                style={{
                                    borderRadius: 8,
                                    background: "linear-gradient(135deg, #6366f1, #4f46e5)",
                                    border: "none",
                                    fontWeight: 600,
                                    padding: "0 20px",
                                }}
                            >
                                {isUpdate ? "Mettre à jour" : "Créer le dossier"}
                            </Button>
                        </Col>
                    </Row>
                </div>
            </Modal>

            {/* ═══ Modal Upload ═══ */}
            <Modal
                title={
                    <Space>
                        <div style={{
                            width: 32, height: 32, borderRadius: 8,
                            background: "linear-gradient(135deg, #06b6d4, #0891b2)",
                            display: "flex", alignItems: "center", justifyContent: "center"
                        }}>
                            <UploadOutlined style={{ color: "#fff", fontSize: 14 }} />
                        </div>
                        <div>
                            <Text strong style={{ fontFamily: "'DM Sans', sans-serif", color: "#1a1a2e" }}>
                                Ajouter un document
                            </Text>
                            {selectedDossier && (
                                <Text style={{ display: "block", fontSize: 12, color: "#6366f1", fontFamily: "'DM Mono', monospace" }}>
                                    {selectedDossier.ref}
                                </Text>
                            )}
                        </div>
                    </Space>
                }
                open={uploadModalOpen}
                onCancel={() => { setUploadModalOpen(false); setUploadedFile(null); setDenomination(""); }}
                footer={null}
                width={480}
                centered
            >
                <div style={{ marginTop: 16 }}>
                    <div style={{ marginBottom: 16 }}>
                        <Text strong style={{ display: "block", marginBottom: 8 }}>Dénomination du document</Text>
                        <Select
                            style={{ width: "100%", borderRadius: 8 }}
                            placeholder="Sélectionner ou saisir la dénomination..."
                            showSearch
                            allowClear
                            value={denomination || undefined}
                            onChange={(val) => setDenomination(val || "")}
                            onSearch={(val) => setDenomination(val)}
                        >
                            {allDocuments && allDocuments.map(item => (
                                <Option key={item.id} value={item.id}>{item.nom}</Option>
                            ))}
                        </Select>
                    </div>
                    <Text strong style={{ display: "block", marginBottom: 8 }}>Fichier</Text>
                    <Dragger
                        beforeUpload={(file) => { setUploadedFile(file); return false; }}
                        onRemove={() => setUploadedFile(null)}
                        maxCount={1}
                        style={{ borderRadius: 12 }}
                    >
                        <p className="ant-upload-drag-icon">
                            <InboxOutlined style={{ color: "#6366f1", fontSize: 36 }} />
                        </p>
                        <p style={{ color: "#1a1a2e", fontWeight: 600, margin: "8px 0 4px" }}>
                            Glissez votre fichier ici
                        </p>
                        <p style={{ color: "#9ca3af", fontSize: 12 }}>
                            PDF, Word, Excel, Image — 20 Mo max
                        </p>
                    </Dragger>
                    {uploadedFile && (
                        <div style={{
                            marginTop: 12, padding: "10px 14px", borderRadius: 10,
                            background: "#f0f1ff", border: "1px solid #c7d2fe",
                            display: "flex", alignItems: "center", gap: 8,
                        }}>
                            <FileTextOutlined style={{ color: "#6366f1" }} />
                            <Text style={{ fontSize: 13, color: "#4338ca" }}>{uploadedFile.name}</Text>
                        </div>
                    )}
                    <Divider style={{ margin: "16px 0" }} />
                    <Row justify="end" gutter={12}>
                        <Col>
                            <Button
                                onClick={() => { setUploadModalOpen(false); setUploadedFile(null); setDenomination(""); }}
                                style={{ borderRadius: 8 }}
                            >
                                Annuler
                            </Button>
                        </Col>
                        <Col>
                            <Button
                                type="primary"
                                icon={<UploadOutlined />}
                                onClick={handleUpload}
                                disabled={!uploadedFile || !denomination}
                                style={{
                                    borderRadius: 8,
                                    background: "linear-gradient(135deg, #06b6d4, #0891b2)",
                                    border: "none",
                                    fontWeight: 600,
                                }}
                            >
                                Ajouter le document
                            </Button>
                        </Col>
                    </Row>
                </div>
            </Modal>

            {/* ═══ Modal Changement de statut ═══ */}
            <Modal
                title="Changer le statut du dossier"
                open={statusModalOpen}
                onCancel={() => setStatusModalOpen(false)}
                onOk={handleChangeStatus}
                okText="Valider"
                cancelText="Annuler"
            >
                <p>Dossier : <strong>{selectedDossier?.ref}</strong></p>
                <Select
                    style={{ width: "100%" }}
                    placeholder="Choisir un statut"
                    onChange={(value) => setNewStatus(value)}
                    options={Object.keys(statusConfig).map((s) => ({ label: s, value: s }))}
                />
            </Modal>

            {/* ═══ Modal Génération / Modification de devis ═══ */}
            {devisModalOpen && (
                <PrestationModal
                    open={devisModalOpen}
                    onClose={() => {
                        setDevisModalOpen(false);
                        setdevisInfo(null);
                    }}
                    selectedDossier={selectedDossier}
                    devisInfo={devisInfo}
                    listeCategories={listeCategories}
                    buildEmptyLine={buildEmptyLine}
                    computeTotal={computeTotal}
                    mapDevisToLines={mapDevisToLines}
                    onSubmit={handleSubmitPrestation}
                />
            )}

            {showToast && <Notification message={notif.message} status={notif.info} />}
        </div>
    );
}